module.exports = __webpack_public_path__ + "img/Arrival__Loading__Icon--has-token@2x.76581572.png";